import { render, staticRenderFns } from "./ActionButton.vue?vue&type=template&id=5d21d4de&scoped=true"
import script from "./ActionButton.vue?vue&type=script&lang=ts"
export * from "./ActionButton.vue?vue&type=script&lang=ts"
import style0 from "./ActionButton.vue?vue&type=style&index=0&id=5d21d4de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d21d4de",
  null
  
)

export default component.exports